import React, { useRef, useState, useLayoutEffect } from 'react';
import { useMenuContext } from '@cko/primitives';
import { getPositionOf } from '../../../utils';
import { SearchInput } from './SearchInput';
import { SearchMenu } from './SearchMenu';
const removeSpaceAroundCharacter = (delimiter, input) => input
    .split(delimiter)
    .map((elem) => elem.trim())
    .join(delimiter);
export const SearchBarContent = ({ onSearch, query, setQuery, entries, helpUrl }) => {
    const [controlWidth, onControlWidthChanged] = useState(0);
    const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });
    const { isOpen, openMenu, closeMenu } = useMenuContext();
    const inputRef = useRef();
    useLayoutEffect(() => {
        setMenuPosition(getPositionOf(inputRef?.current));
    }, []);
    const updateQuery = ({ target }) => {
        openMenu();
        setQuery(target.value);
    };
    const clearValueAndSubmit = () => {
        submitQuery(false, '');
        setQuery('');
        inputRef?.current?.focus();
    };
    const submitQuery = (blurInput = true, overrideQuery) => {
        const queryToUse = overrideQuery === undefined ? query : overrideQuery;
        // This used to be: `const searchQuery = queryToUse.replace(/\s*(:|=)\s*/g, '$1');`, but the double infinite white space selectors causes a recursive query
        // creating a potential performance based denial of service. So lets do each step in sequence without regex.
        const searchQuery = removeSpaceAroundCharacter(':', removeSpaceAroundCharacter('=', queryToUse));
        onSearch(searchQuery);
        if (inputRef?.current && blurInput) {
            inputRef?.current.blur();
        }
    };
    const submitForm = (event) => {
        event.preventDefault();
        submitQuery();
        closeMenu();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(SearchInput, { inputRef: inputRef, submit: submitForm, onChange: updateQuery, isPanelOpen: isOpen, value: query, onFocus: openMenu, onClear: clearValueAndSubmit, onInputWidthChange: onControlWidthChanged }),
        React.createElement(SearchMenu, { isOpen: isOpen, width: controlWidth, query: query, setQuery: setQuery, onSubmit: submitForm, position: menuPosition, entries: entries, helpUrl: helpUrl })));
};
